import {Deserializable} from "../deserializable.model"


export class Contactus{
    constructor(
      public UserId: string = '',
      public clientname: string = '',    
      public usecase: string = '',
      public clientmarket: string = '',   
      public clientindustry: string = '',
      public additionalinfo: string = '',
      public AppType: string = '',
      public oppurtunityId:string='',
      public dealValue:string =''

   ) {}
  
  }

export class FileDownloadpath {
    Filepath! : string;
    Filename! : string;
}

 export class UseCase implements Deserializable
    {
      UseCaseId! : number;
      UseCaseDesc!: string;

        deserialize(input: any) {
            Object.assign(this, input);
            return this;
          }
    }


    export class ClientMarket implements Deserializable
    {
      GeoId! : number;
      GeoDesc!: string;

        deserialize(input: any) {
            Object.assign(this, input);
            return this;
          }
    }

    export class ClientIndustry implements Deserializable
    {
      IgId! : number;
      IgDesc!: string;

        deserialize(input: any) {
            Object.assign(this, input);
            return this;
          }
    }
